import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./Nav";

export default function Emergency() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section
      ref={ref}
      className="relative py-24 md:py-36 overflow-hidden border-b border-white/10"
      data-testid="emergency-section"
    >
      <motion.div style={{ y }} className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxIVkFDJTIwdGVjaG5pY2lhbiUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzg3OTIyODc3fDA&ixlib=rb-4.1.0&q=85"
          alt="Industrial HVAC units"
          className="w-full h-[130%] object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/70 to-[#050505]" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#FF6B00] mb-6"
          data-testid="emergency-eyebrow"
        >
          Nights — Weekends — Holidays
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold uppercase tracking-tighter text-5xl md:text-7xl lg:text-8xl leading-[0.9] mb-10"
        >
          HVAC
          <br />
          <span className="text-[#FF6B00]">Emergency?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="max-w-lg text-zinc-300 text-base md:text-lg mb-12"
        >
          Don't sit in a freezing house or a sweltering one. One call and a real
          East TN tech is on the way — any hour, any day.
        </motion.p>
        <motion.a
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.3 }}
          href={PHONE_TEL}
          className="animate-pulse-ring inline-flex items-center gap-4 bg-[#FF6B00] hover:bg-[#E66000] text-[#050505] font-display font-bold uppercase tracking-wide text-xl md:text-3xl px-8 md:px-12 py-5 md:py-7 rounded-sm transition-colors duration-300"
          data-testid="emergency-call-button"
        >
          <Phone className="w-6 h-6 md:w-8 md:h-8" strokeWidth={2.5} />
          {PHONE_DISPLAY}
        </motion.a>
      </div>
    </section>
  );
}
